export const CREATE_ADDRESS = 'createAddress'
export const DELETE_ADDRESS = 'deleteAddress'
export const GET_ADDRESS = 'getAddress'
export const GET_ADDRESSES = 'getAddresses'
export const GET_SHOP_ADDRESSES = 'getShopAddresses'
export const GET_ADDRESS_TEMPLATES = 'getAddressTemplates'
export const SET_ADDRESS_AS_DEFAULT = 'setAddressAsDefault'
export const UPDATE_ADDRESS = 'updateAddress'
